// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__yliT4","info":"Note_info__2Y7tQ","note":"Note_note__2AOiG","actions":"Note_actions__Amody"};